function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M14 8.6665V15.3332H0V2.6665H8V3.99984H1.33333V13.9998H12.6667V8.6665H14ZM16 0.666504H8.67467L11.3647 3.33317L6.71333 8.0465L8.59867 9.93184L13.25 5.2185L16 7.99984V0.666504Z",
  fill: "white"
}));

function SvgExplorer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExplorer);
export default __webpack_public_path__ + "static/media/explorer.70269b8075a38012425681725c698865.svg";
export { ForwardRef as ReactComponent };